<template>
  <footer class="footer">
    <div class="has-text-centered">
      <strong>Wizard Bridge EVM | Fact Protocol Interface : (Proof of Message)</strong>
      
    <!-- <br>
      by
      <a href="https://">Ivan</a>. The source code is
      licensed
      <a href="http://opensource.org/licenses/mit-license.php">MIT</a> -->

    </div>

    <br>

    <div class="has-text-centered">
    <section class="mb-4 text-center">
        <!-- Gibook -->
        <a target="_blank" rel="noopener noreferrer"
          class="btn btn-outline-light btn-floating m-1"
          href="https://wizard-bridge-evm.gitbook.io/docs/"
          role="button"
          ><i class="fa fa-book"></i
          ></a>

        <!-- Twitter -->
        <a target="_blank" rel="noopener noreferrer"
           class="btn btn-outline-light btn-floating m-1"
           href="https://twitter.com/wizardbridgeevm"
           role="button"
           ><i class="fab fa-twitter"></i
          ></a>

        <!-- Facebook -->
        <a target="_blank" rel="noopener noreferrer"
           class="btn btn-outline-light btn-floating m-1"
           href="https://www.facebook.com/profile.php?id=61551776916251"
           role="button"
           ><i class="fab fa-facebook-f"></i
          ></a>

        <!-- Github -->
        <a target="_blank" rel="noopener noreferrer"
           class="btn btn-outline-light btn-floating m-1"
           href="https://github.com/Wizard-Bridge-EVM"
           role="button"
           ><i class="fab fa-github"></i
        ></a>

        <!-- Google -->
        <!-- <a
           class="btn btn-outline-light btn-floating m-1"
           href="#!"
           role="button"
           ><i class="fab fa-google"></i
          ></a> -->

        <!-- Instagram -->
        <!-- <a
           class="btn btn-outline-light btn-floating m-1"
           href="#!"
           role="button"
           ><i class="fab fa-instagram"></i
          ></a> -->

      </section>

      <p style="font-size: 50%; ">© 2023 Copyright: Wizard Bridge EVM</p>
    </div>

  </footer>
  <br>
</template>

<script>
export default {
}
</script>

<style scoped>
footer {
  padding: 2rem 0.5rem 2rem;
}
</style>
